import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';  // Import withRouter
import Topbar from '../../../Layout/topbar/Topbar';  // Import Topbar component
import Card from './Card';  // Import the Card component
import './Card.css';  // Optional, for global styles
import Util from "../../../Common/util";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCard: '', // Initially, no card is active
      zoomLevel: 1,  // Default zoom level (1 = 100%)
      cards: [
        { id: 'Card 1', heading: 'Health Check Report', subHeading: 'Can view report here', route: '/wmsReports/health_check_report', show: false },
        { id: 'Card 2', heading: 'PO to GRN', subHeading: 'Can view report here', route: '/wmsReports/po_to_grn_report', show: false },
        { id: 'Card 3', heading: 'Receiving Short Report', subHeading: 'Can view report here', route: '/wmsReports/po_sort_report', show: false },
        { id: 'Card 4', heading: 'Inbound Delivery Report', subHeading: 'Can view report here', route: '/wmsReports/inbound_delivery', show: false },
        { id: 'Card 5', heading: 'ASN/Invoice Report', subHeading: 'Can view report here', route: '/wmsReports/asn_invoice', show: false },
        { id: 'Card 6', heading: 'Receiving Report', subHeading: 'Can view report here', route: '/wmsReports/receiving', show: false },
        { id: 'Card 7', heading: 'Sales Return Report', subHeading: 'Can view report here', route: '/wmsReports/sales_return', show: false },
        { id: 'Card 8', heading: 'Sales Return To GR Report', subHeading: 'Can view report here', route: '/wmsReports/sales_return_gr', show: false },
        { id: 'Card 9', heading: 'Purchase Return Report', subHeading: 'Can view report here', route: '/wmsReports/purchase_return_report', show: false },
        { id: 'Card 10', heading: 'Putaway Report', subHeading: 'Can view report here', route: '/wmsReports/putaway_report', show: false },
        { id: 'Card 11', heading: 'Inbound Summary Report', subHeading: 'Can view report here', route: '/wmsReports/inbound_summary_report', show: false },
      ],
    };
  }

  componentDidMount() {
    this.detectZoomLevel();  // Detect zoom level on mount
    console.log("SIDEBAR", window.location.pathname);
    var directPutawayFlag = Util.getCookie("direct_putaway_flag");
    console.log('directPutawayFlag', directPutawayFlag);
    var NAV = Util.getCookie("userMenu").split("-");
    console.log('NAV', NAV);
    var location = Util.getCookie("selectedLocation");

    // Dynamically show/hide cards based on location and user permissions
    const updatedCards = [...this.state.cards];

    if (location.toLowerCase() === "vapi") {
      this.setState({
        showUpload: true,
        showBill: true,
      });
    } else {
      this.setState({
        showUpload: true,
        showBill: true
      });
    }

    // Set state based on the user's menu permissions
    if (NAV.indexOf("7.1.3") > -1) {
      updatedCards[0].show = true;
    }
    if (NAV.indexOf("7.1.2") > -1) {
      updatedCards[1].show = true;
    }
    if (NAV.indexOf("7.1.9") > -1) {
      updatedCards[2].show = true;
    }
    if (NAV.indexOf("7.1.4") > -1) {
      updatedCards[3].show = true;
    }
    if (NAV.indexOf("7.1.5") > -1) {
      updatedCards[4].show = true;
    }
    if (NAV.indexOf("7.1.6") > -1) {
      updatedCards[5].show = true;
    }
    if (NAV.indexOf("7.1.7") > -1) {
      updatedCards[6].show = true;
    }
    if (NAV.indexOf("7.1.8") > -1) {
      updatedCards[7].show = true;
    }
    if (NAV.indexOf("7.1.10") > -1) {
      updatedCards[8].show = true;
    }
    if (NAV.indexOf("7.1.11") > -1) {
      updatedCards[9].show = true;
    }
    if (NAV.indexOf("7.1.12") > -1) {
      updatedCards[10].show = true;
    }

    this.setState({ cards: updatedCards });
  }

  detectZoomLevel() {
    // Get the zoom level (device pixel ratio)
    const zoomLevel = window.devicePixelRatio || 1;
    this.setState({ zoomLevel });
  }

  handleCardClick = (cardName, url) => {
    this.setState({ activeCard: cardName });
    this.props.history.push(url);
  };

  chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  render() {
    const { activeCard, cards, zoomLevel } = this.state;
    const rows = this.chunkArray(cards.filter(card => card.show), 4);  // Chunk only visible cards into rows of 4

    // Adjust the layout and heading font size based on zoom level
    let cardSizeClass = '23%';
    let headingFontSize = '19px';  // Default font size for normal zoom
    let subHeadingFontSize = '14px'; // Default subheading font size
    let imageSize = "12px";  // Default image size
    let imagemaginLeft = "2%";

    if (zoomLevel >= 1.5) {
      cardSizeClass = '23%';
      headingFontSize = '14px';  // Larger font for zoom levels 1.5 and above
      subHeadingFontSize = '11px'; // Smaller subheading for zoom levels 1.5 and above
      imageSize = '10px'; // Smaller image for zoom levels 1.5 and above
      imagemaginLeft = "3%";
    } else if (zoomLevel >= 1.25) {
      cardSizeClass = '23%';
      headingFontSize = '15px';  // Larger font for zoom levels 1.25 and above
      subHeadingFontSize = '13px'; // Smaller subheading for zoom levels 1.25 and above
      imageSize = '5px'; // Adjusted image size for zoom levels 1.25
      imagemaginLeft = "3%";
    } else if (zoomLevel >= 1.1) {
      cardSizeClass = '23%';
      headingFontSize = '19px';  // Larger font for zoom levels <= 1.1
      subHeadingFontSize = '15px'; // Larger subheading for zoom levels 1.1
      imageSize = '12px'; // Larger image for zoom levels <= 1.1
      imagemaginLeft = "2%";
    }

    return (
      <div className="app1">
        <div className="card-container">
          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className="card-row">
              {row.map((card, cardIndex) => (
                <Card
                  key={cardIndex}
                  heading={card.heading}
                  subHeading={card.subHeading}
                  route={card.route}
                  onClick={() => this.handleCardClick(card.id, card.route)}
                  isActive={activeCard === card.id}
                  className={cardSizeClass} // Apply zoom-based class to cards
                  cardSizeClass={cardSizeClass}
                  headingFontSize={headingFontSize} // Pass heading font size as a prop
                  subHeadingFontSize={subHeadingFontSize} // Pass subheading font size
                  imageSize={imageSize}  // Pass image size as a prop
                  imagemaginLeft = {imagemaginLeft}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(App);
